import selectorMod from '../../../../common/material-components/selects/select.component';
import selectorTpl from './selector.tpl.html';
import './selector.scss';

const REQUIRED_IMPORTS = [
  selectorMod
];

/**
 * Generic searchable dropdown selector.
 * Should be extended by a component class. The objects in the dropdown should have an attribute
 * 'label' that is used as the label.
 */
class Selector {
  /**
   * @param {String} label
   */
  constructor(label) {
    /**
     * Label text to show above dropdown.
     * @type {String}
     */
    this.label = label;
  
    /**
     * A possible id name for selector menu that can be used for CSS targetting.
     * @type {?String}
     */
    this.menuId = null;

    /**
     * Extra classes to add to the select
     */
    this.extraClasses = null;

    /**
     * List of objects to show in dropdown.
     * @type {Array.<Object>}
     */
    this.objs = [];

    /**
     * Is this loading new data?
     * @type {boolean}
     */
    this.loading = false;

    /**
     * Function to call when object is selected
     * @type {Function}
     */
    this.callback = null;

    /**
     * Custom loading text to show next to the selector while selector is updating.
     * @type {?String}
     */
    this.loadingText = null;

    /**
     * The selected object, changed by the parent component
     * @type {Object}
     */
    this.object = null;

    // Internal model changed by the select
    this._model = null;
  }

  /**
   * Function that should return the objects to display in the dropdown. Must return a promise that resolves to a
   * ResourceCollection of the objects to display or reject if fetch failed. Override in child classes.
   */
  loadData() {
    throw new Error('loadData must be implemented');
  }

  /**
   * Called when a selection is made. Extend in child classes.
   */
  onSelect() {
    this.object = this._model;
  }

  /**
   * Called on key up. Calls onCleared() if model empty.
   */
  onKeyUp() {
    if (!this._model) {
      this._model = null;
      this.onCleared();
    }
  }

  /**
   * Implement in child classes to act after data has been loaded.
   */
  onPostInit() {
  }

  /**
   * Called when model is cleared. Extend in child classes.
   */
  onCleared() {
    this.onSelect();
  }

  $onInit() {
    // Start loading objects immediately on startup
    this.loading = true;

    this.loadData().then(data => {
      this.objs = data;
      this.failed = false;
    }).catch(() => {
      this.objs = [];
      this.failed = true;
    }).finally(() => {
      this.loading = false;
      this.onPostInit();
    });
  }
  $onChanges() {
    this._setObject();
  }

  _setObject() {
    this._model = this.object;
  }
}

export {selectorTpl, REQUIRED_IMPORTS};
export default Selector;
